
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'ShootingPinControls',

  props: {
    activePointIsPinnable: Boolean,
    activePointIsUnpinnable: Boolean,
    hasPreviousPanorama: Boolean,
    hasNextPanorama: Boolean,
  },
})
export default class ShootingPinControls extends Vue {}
